import { useScrollAnimation } from '../hooks/useScrollAnimation';
import { Quote, Star } from 'lucide-react';

const testimonials = [
  {
    quote: "Darkforce transformed how we manage Amazon. The AI insights surface opportunities we'd never catch manually, and the team's responsiveness is unmatched.",
    metric: 'ACOS reduced from 26% to 18%',
  },
  {
    quote: "Finally, an agency that actually understands data. Their reports are clear, their recommendations are actionable, and the results speak for themselves.",
    metric: 'Revenue up 41% in 6 months',
  },
  {
    quote: "The Buy Box monitoring alone saved us thousands. We used to lose the Buy Box and not know for hours. Now we get alerts instantly.",
    metric: 'Buy Box win rate: 96%',
  },
  {
    quote: "We interviewed five agencies. Darkforce was the only one that talked about strategy, not just tactics. They're true partners.",
    metric: 'ROAS improved to 4.8x',
  },
];

export default function TestimonialsSection() {
  const { ref: sectionRef, isVisible } = useScrollAnimation<HTMLElement>({ threshold: 0.1 });

  return (
    <section
      ref={sectionRef}
      className="relative bg-[#05060B] grid-bg py-20 lg:py-24 overflow-hidden"
    >
      <div className="relative z-10 w-full px-6 lg:px-12 xl:px-20">
        <div className="max-w-7xl mx-auto">
          <div 
            className={`text-center mb-12 transition-all duration-1000 ${
              isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
            }`}
          >
            <span className="inline-block px-4 py-2 rounded-full bg-cyan-500/10 border border-cyan-500/20 text-cyan-400 text-xs font-medium uppercase tracking-wider mb-6">
              Client Feedback
            </span>
            <h2 className="font-heading font-bold text-3xl sm:text-4xl lg:text-5xl text-white mb-6">
              What our clients{' '}
              <span className="text-cyan-400 cyan-glow">say.</span>
            </h2>
          </div>

          <div className="grid md:grid-cols-2 gap-6">
            {testimonials.map((testimonial, index) => (
              <div
                key={index}
                className={`glass-card p-6 group hover-lift transition-all duration-500 ${
                  isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
                }`}
                style={{ transitionDelay: `${index * 100 + 200}ms` }}
              >
                <div className="flex gap-1 mb-4">
                  {[...Array(5)].map((_, i) => (
                    <Star key={i} className="w-4 h-4 text-cyan-400 fill-cyan-400" />
                  ))}
                </div>

                <div className="relative mb-6">
                  <Quote className="absolute -top-2 -left-2 w-6 h-6 text-cyan-500/20" />
                  <p className="text-dark-300 leading-relaxed relative z-10 text-sm">
                    "{testimonial.quote}"
                  </p>
                </div>

                <div className="pt-4 border-t border-cyan-500/10">
                  <span className="text-xs text-cyan-400 font-medium">{testimonial.metric}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
